import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { sawinFunc, ResetStore, APIContainer, LogTypes } from './sawinLib';
import * as ServiceContractMaintSchdMdls from '../models/ServiceContractMaintScheduleModel';

export interface ServiceContractScheduleLoad { type: 'SERVICECONTRACTMAINTSCHEDULE_LOAD', newState: ServiceContractMaintSchdMdls.ServiceContractMaintScheduleList }
export interface ServiceContractScheduleLoading { type: 'SERVICECONTRACTMAINTSCHEDULE_LOADING' }

export type KnownAction = ServiceContractScheduleLoad | ServiceContractScheduleLoading | ResetStore;

export const actionCreators = {
    loadServiceContractSchedule: (ContractNumber: string): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();

        //var ServiceMasterNumber = appState.sessionState.SelectedSM.id;
        var CompanyCode = appState.sessionState.SelectedAR.companyCode;

        dispatch({ type: 'SERVICECONTRACTMAINTSCHEDULE_LOADING' });
        var fetchURL = `api/Proxy/MaintenanceSchedule?CompanyCode=${CompanyCode}&ContractNumber=${ContractNumber}`;
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + fetchURL,
            {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {              
                if (container.success) {
                    const schedList: ServiceContractMaintSchdMdls.ServiceContractMaintScheduleList = { loading: false, items: container.data };
                    dispatch({ type: 'SERVICECONTRACTMAINTSCHEDULE_LOAD', newState: schedList });
                } else {
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }
            });
    } 
};

export const reducer: Reducer<ServiceContractMaintSchdMdls.ServiceContractMaintScheduleList> = (state: ServiceContractMaintSchdMdls.ServiceContractMaintScheduleList | undefined, incomingAction: Action): ServiceContractMaintSchdMdls.ServiceContractMaintScheduleList => {

    if (state === undefined) {
        return { ...ServiceContractMaintSchdMdls.maintScheduleinitialState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'SERVICECONTRACTMAINTSCHEDULE_LOADING':
            return { ...state, loading: true }
        case 'SERVICECONTRACTMAINTSCHEDULE_LOAD':
            const actionPayload = incomingAction as ServiceContractScheduleLoad;
            //console.log(`New State ${JSON.stringify(actionPayload.newState)}`);
            return { ...state, ...actionPayload.newState, loading: false }
        case 'STORE_RESET':
            return { ...ServiceContractMaintSchdMdls.maintScheduleinitialState };
        default:
            return state;
    }
}; 